<div class="addPointModel">
  <div class="titleText">Add Point</div>
  <div class="flex-body relative" #pamBuilderContent>
    <div class="row spaceEvenlyflex">
      <div class="col-3 graphConfigCol p-l-0">
        <div class="labelText">
          Select Build Type
        </div>
        <div class="btn-group d-flex m-t-10">
          <button (click)="changeBuildType()" class="btn w-100"
            [ngClass]="{'btn-outline-primary color-primary':!isCustom}">
            BUILDER
          </button>
          <button (click)="changeBuildType()" class="btn w-100"
            [ngClass]="{'btn-outline-primary color-primary': isCustom}">
            CUSTOM
          </button>
        </div>
        @if (showBuildChangeWarning) {
          <div class="row align-items-start m-t-30 m-b-10 warningtext">
            <div class="col-2 text-center">
              <i class="fa fa-exclamation-triangle color-primary fa-lg m-t-10"></i>
            </div>
            <div class="col-10 p-l-0 pre-wrap">
              <p class="warningtext">Are you sure you want to change widget type to <b>{{buildTypechange}}
              ?</b>
            </p>
            <p>Changes you made so far will be lost</p>
            <div class="d-flex justify-content-end">
              <button class="btn btn-text" (click)="showBuildChangeWarning = false;"> Cancel</button>
              <button class="btn btn-text" (click)="buildWarningSelected()">
              Change</button>
            </div>
          </div>
        </div>
      }
      <div [ngClass]="{'visible':showBuildChangeWarning}">
        <div class="labelText m-t-16">
          Scope
        </div>


        @if (isCustom) {
          <site-selector [scope]=sites defaultSelection='all'
            placeholder="Select Scope" class="selectorFormField siteSelector editor notranslate"
            (scopeSelectionChangeEvent)="scopeChanged($event)" [disableTranslation]="true">
          </site-selector>
        }

        @if (!isCustom) {
          <site-selector [scope]=sites defaultSelection='all'
            placeholder="Select Scope" class="selectorFormField siteSelector editor notranslate"
            (scopeSelectionChangeEvent)="scopeChanged($event)" [disableTranslation]="true">
          </site-selector>
        }
      </div>

      @if (!isCustom) {
        <div>
          <div class="labelText m-t-16">
            Tags
          </div>
          <ng-select class="custom-select notranslate" [items]="tagList" color="primary" [multiple]="true" #tagSelect
            (add)="onTagSelect($event)" (remove)="onTagDeSelect($event)" (clear)="onTagsClear()"
            [searchFn]="searchTag" addTagText="" [clearOnBackspace]="true" [markFirst]="markFirst()"
          dropdownPosition="top" [clearSearchOnAdd]="false" [(ngModel)]="selectedTags"></ng-select>
        </div>
      }
    </div>
    <div [ngClass]="{'visible':(selectedSites.length == 0),'graphConfigCol':((!isCustom && equipList.length > 0) || isCustom) }"
      class="col-4 p-l-0">

      @if (equipList?.length > 0 && !isCustom) {
        <div>
          @if (!isCustom && selectedSites.length > 0) {
            <div class="eqipText d-flex">Equip <span
            class="eqipNumber p-l-3"> ({{selectedEquipsId.length}}/{{equipList.length}})</span> <span
            class="switch d-flex p-l-8">
            <mat-slide-toggle [(ngModel)]="isQueryMode">
            </mat-slide-toggle>
            <span class="queryLabel" (click)=queryView()>Query </span>
          </span></div>
        }
      </div>
    }
    <!-- Query  -->
    @if (isQueryMode || isCustom) {
      <textarea #queryElem class="query-textarea m-t-5"
        [ngClass]="{'readonlyTextbox': !isCustom}" [readonly]="!isCustom" autofocus spellcheck="false"
        [(ngModel)]="hayStackQuery" placeholder="Enter your query here"
        [ngModelOptions]="{standalone: true}">
      </textarea>
    }

    @if (!isQueryMode && !isCustom && equipList?.length > 0 ) {
      <div>
        <div class="pointSearchInput">
          <mat-form-field class="search-input" [floatLabel]="'never'">
            <input matInput placeholder="Search Equip" [(ngModel)]="equipSearch" autocomplete="off" />
          </mat-form-field>
        </div>
        <div class="node-content">
          <ul class="list-none">
            @for (equipdata of equipList | filter:equipSearch:'dis'; track trackByPoints($index, equipdata)) {
              <li class="node" [ngClass]="{'selected':(equipdata.checked)}"
                (click)="onEquipSelect(equipdata)"
                >
                <span class="notranslate">{{equipdata?.pointName}}</span>
              </li>
            }
          </ul>
        </div>
      </div>
    }

    <div class="text-center p-t-12">
      @if (isCustom) {
        <div (click)="getPoints()"
          [ngClass]="{'executeQueryDisabled': !selectedSites?.length || !hayStackQuery?.length}"
          class="retriveText text-uppercase">
          @if (!fetchingPoints) {
            <span>Execute Query</span>
          }
          @if (fetchingPoints) {
            <span>Executing ...</span>
          }
        </div>
      }

      @if (!isCustom && equipList?.length > 0 && !isCustom) {
        <div (click)="getPoints()"
          [ngClass]="{'executeQueryDisabled':!selectedSites?.length || (!isCustom && !selectedTags?.length)}"
          class="retriveText text-uppercase">
          @if (!fetchingPoints) {
            <span>Retrieve points</span>
          }
          @if (fetchingPoints) {
            <span>Retrieving ...</span>
          }
        </div>
      }


    </div>


    @if (equipCalled && !isCustom &&  equipList?.length === 0 && selectedSites?.length > 0) {
      <div
        class="p-t-20">
        <div class="h-100 warningNoPoint d-flex justify-content-center">
          <i class="fas fa-exclamation-triangle warningIcon"></i>
          <div class="m-l-10">
            <div>There are no points available for the current selection !</div>
          </div>
        </div>
      </div>
    }

  </div>
  <div class="col-4 p-l-0">
    @if (selectedSites.length > 0 &&  pointList.length > 0) {
      <div>
        <div class="eqipText">Points <span
        class="eqipNumber">({{selectedPoint.length}}/{{pointList.length}})</span>
      </div>
      <div class="pointSearchInput">
        <mat-form-field class="search-input" [floatLabel]="'never'">
          <input matInput placeholder="Search Point" [(ngModel)]="pointSearch" autocomplete="off" />
        </mat-form-field>
      </div>
      <div class="node-content">
        <ul class="list-none">
          @for (pointData of pointList | filter:pointSearch:'dis'; track trackByPoints($index, pointData)) {
            <li class="node" [ngClass]="{'selected':(pointData.checked)}"
              (click)="onPointSelect(pointData)"
              >
              <span class="notranslate">{{pointData?.pointName}}</span>
            </li>
          }
        </ul>
      </div>
    </div>
  }
  @if (pointsCalled && pointList?.length === 0 && selectedSites?.length > 0) {
    <div class="p-t-20">
      <div class="h-100 warningNoPoint d-flex justify-content-center">
        <i class="fas fa-exclamation-triangle warningIcon"></i>
        <div class="m-l-10">
          <div>There are no points available for the current selection !</div>
        </div>
      </div>
    </div>
  }

  @if (hasError) {
    <div class="p-t-20">
      <div class="h-100 warningNoPoint d-flex justify-content-center">
        <i class="fas fa-exclamation-triangle warningIcon"></i>
        <div class="m-l-10">
          <div>{{errorTxt}}</div>
        </div>
      </div>
    </div>
  }
</div>
</div>
</div>


</div>

<div mat-dialog-actions>
  <div class="flex-footer  d-flex justify-content-end p-r-30 p-b-16">
    <div class="col-9 d-flex justify-content-end align-items-center">
      <button (click)="cancel()"
      class="text-uppercase btn btn-outline-primary color-primary text-uppercase">Cancel</button>

      <button (click)="addPoint()" class="text-uppercase btn btn-outline-primary color-primary text-uppercase"
      [ngClass]="{'disabled' : !isPointSelected}" [disabled]="!isPointSelected">Add Point</button>

    </div>
  </div>
</div>